export const maxStudyAdditionalSections = 10;
export const maxStudySectionImages = 5;
export const minPasswordLength = 8;
export const passwordExpiryInDays = 180;
export const defaultPageSize = 100;
export const CREDENTIAL_ROUTES = [
    "/auth/token",
    "/auth/logout",
    "/auth/switch-account",
    "/auth/verification/pending",
    "/auth/verification/send",
    "/auth/verification/verify",
    "/auth/verification/complete",
    "/auth/login-state",
    "/auth/send-otp",
    "/auth/verify-otp",
    "/auth/device-hint",
];
export function isCredentialRoute(path) {
    return CREDENTIAL_ROUTES.includes(path);
}
